<template>
	<transition name="show" @after-leave="afterLeave">
		<div v-show="modal.show" class="modal is-active custom-modal" :id="modalId" :style="{ 'z-index': zIndex }" @click="onClickBg">
			<template v-if="!isOverlay">
				<div class='modal-background'></div>
				<div class="modal-content" :class="{'fullscreen': modal.fullscreen }">
					<component :is="currentComponent" :close="close" :modalData="modal" />
				</div>
				<button class="modal-close is-large" aria-label="close" @click="close(null)"></button>
			</template>
		</div>
	</transition>
</template>

<script lang="ts">
import { ModalItem } from '@/models/AppConfig'
import { STATE_MODULES } from '@/store/state-modules';
import { ConfigMutations } from '@/store/modules/config/mutations';
import { defineComponent, Component } from 'vue'
import ModalManager from '@/utils/modal';
import utils from '@/utils/utils';

export default defineComponent({
	mounted () {
		this.$store.commit(`${STATE_MODULES.CONFIG}/${ConfigMutations.CHANGE_MODAL_SHOW}`, { uuid: this.modal.uuid, show: true });
	},
	methods: {
		afterLeave () {
			this.$store.commit(`${STATE_MODULES.CONFIG}/${ConfigMutations.REMOVE_MODAL}`, this.modal)
		},
		close (payload: any = null) {
			ModalManager.deleteModal(this.modal.uuid, payload);
			this.$store.commit(`${STATE_MODULES.CONFIG}/${ConfigMutations.CHANGE_MODAL_SHOW}`, { uuid: this.modal.uuid, show: false });
		},
		onClickBg () {
			if (this.isOverlay) {
				this.close();
			}
		}
	},
	computed: {
		currentComponent (): Component | null {
			return ModalManager.getComponent(this.modal.uuid) || null
		},
		zIndex () : number {
			return this.index + 50
		},
		isOverlay (): boolean {
			return this.modal.type === 'overlay';
		},
		modalId (): string {
			return utils.generateOverlayModalId(this.modal.uuid);
		}
	},
	props: {
		modal: {
			type: Object as () => ModalItem,
			required: true
		},
		index: {
			type: Number,
			required: true
		}
	}
})
</script>

<style scoped>
	.custom-modal{
		opacity: 1;
	}

	.modal-content.fullscreen{ 
		max-width: 100vw;
		max-height: 100vh;
		width: 100%;
		height: auto;
		overflow: hidden;
		text-align: center;
	}

	.show-enter-active, .show-leave-active, .show-enter-to, .show-leave-from {
		transition: all 0.5s ease;
	}

	.show-enter-from, .show-leave-to {
		opacity: 0;
		overflow: hidden;
	}
</style>
